import React from 'react';

import { useIntl } from 'react-intl';

import { Calories } from 'components/price-and-calories';
import { HapticsImpactStyle, hapticImpact } from 'utils/haptic';

import {
  CartItemButton,
  CartItemCalories,
  CartItemDetails,
  CartItemIcon,
  CartItemInfo,
  CartItemName,
  CartItemPicture,
  CartItemPrice,
} from './styles';
import { ICartItemProps } from './types';
import { useCartItem } from './use-cart-item';

export const CartItem = ({ item, addToCard, logEventData }: ICartItemProps) => {
  const { finalCalories, price, itemCalories } = useCartItem({ item, logEventData });

  const { formatMessage } = useIntl();

  return (
    <CartItemButton
      data-testid="cart-add-to-order-btn"
      aria-label={formatMessage({ id: 'addItemLabel' }, { itemName: item.name?.locale })}
      onClick={() => {
        hapticImpact({ style: HapticsImpactStyle.Heavy });
        addToCard(item);
      }}
    >
      <CartItemInfo
        aria-label={formatMessage(
          { id: 'cartItemLabel' },
          {
            itemName: item.name?.locale,
            calories: itemCalories,
            price,
          }
        )}
      >
        <CartItemPicture image={item.image} alt={item.name?.locale} />
        <CartItemDetails
          tabIndex={0}
          aria-labelledby={`add-to-order-header cart-name-${item._id} cart-price-${item._id} cart-calories-${item._id}`}
        >
          <CartItemName id={`cart-name-${item._id}`}>{item.name?.locale}</CartItemName>
          <CartItemPrice id={`cart-price-${item._id}`}>
            <span data-testid={`cart-price-text-${item._id}`}>{price}</span>
          </CartItemPrice>
          <Calories>
            {' '}
            |<CartItemCalories id={`cart-calories-${item._id}`}>{finalCalories}</CartItemCalories>
          </Calories>
        </CartItemDetails>
      </CartItemInfo>
      <CartItemIcon>+</CartItemIcon>
    </CartItemButton>
  );
};
